exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@media (min-width: 1024px){.mobile-only{display:none !important}}@media (max-width: 1023px){.desktop-only{display:none !important}}.sf-overlay{position:fixed;top:0;right:0;bottom:0;left:0;z-index:var(--overlay-z-index, 1);background:var(--overlay-background, rgba(var(--c-gray-base), 0.7))}\n", ""]);

// exports
